import { Component, inject, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { CrudViewComponent } from '../../../shared/components/crud/view/view';
import { ActivatedRoute } from '@angular/router';
import { Titledescription } from '../../../shared/components/titledescription/titledescription.component';
import { TituloInterface } from '../../../models/titulo.model';
import { TituloService } from '../../../core/titulo.service';
import { BaseCrud, typeAction } from '../../../shared/baseCrud.component';
import { TITULOS_COLUMN_NAMES_DETAILS } from '../../../constants/titulos.constants';

@Component({
  selector: 'app-titulos-view',
  imports: [CommonModule, MatListModule,CrudViewComponent],
  templateUrl: './titulos-view.html',
  styleUrl: './titulos-view.scss'
})
export class TitulosViewComponent extends BaseCrud<TituloInterface> {
  type = <typeAction>'view';
  apiService = inject(TituloService);
  columnNames = TITULOS_COLUMN_NAMES_DETAILS;
}
